<template>
    <div id="toolbar-top">
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <div class="tournament-card-header header-live market-view">
                    <div class="tournament-card-header header-live market-view">

                        <v-btn @click="homeHandlerAndResetState" small text v-if="this.getViewMode == 'detail'">
                            {{$t('prematch')}}
                        </v-btn>
                        <v-btn @click="liveHandler" small text v-if="this.getViewMode == 'preview'">
                            {{$t('live')}}
                        </v-btn>
                    </div>
                </div>
            </v-col>

        </v-row>
    </div>

</template>

<script>


    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'ToolbarTop',
        data() {
            return {
                selected: null
            }
        },
        components: {},
        computed: {
            ...mapGetters({
                'getEventsLiveDetail': 'odds/getEventsLiveDetail',
                'getViewMode': 'ui/getViewMode',
            }),

        },
        methods: {
            ...mapActions({
                'setViewMode': 'ui/setViewMode',
                'closePrematchEventsCards': 'odds/closePrematchEventsCards'
            }),

            homeHandler() {
                this.setViewMode({mode: 'preview'});
                this.selected = 'home'
            },

            homeHandlerAndResetState() {
                if (localStorage.getItem('event-detail')) {
                    localStorage.removeItem('event-detail');
                }
                if (localStorage.getItem('preview-tournament-visited')) {
                    localStorage.removeItem('preview-tournament-visited');
                }

                this.homeHandler();
                this.closePrematchEventsCards();
                //this.setMenu(false);
            },

            liveHandler() {
                this.setViewMode({ mode: 'detail', section: 'live' });
                this.selected = 'live';
                window.parent.postMessage({ type: 'liveSectionEntered' }, '*');
                // this.setMenu(false);
            },
            // setMenu(status) {
            //     this.drawer = status;
            //     this.setProgramOpen(this.drawer);
            // }

        }
    }
</script>
